import { render, staticRenderFns } from "./MobileDevice.vue?vue&type=template&id=6fab9d77&lang=pug&"
import script from "./MobileDevice.vue?vue&type=script&lang=js&"
export * from "./MobileDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports